import PolygonBase from './PolygonBase';
import shapeIcon from '../assets/icons/shapeManualInput.svg';
import { svgToIcon } from '../utils/svg';

const HEIGHT_FACTOR = 0.5;

class ShapeManualInput extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeIcon);
  }

  static defaultHeight() {
    return this.defaultWidth() * HEIGHT_FACTOR;
  }

  static pathString() {
    return `
      M -0.5 -0.2
      L 0.5 -0.5
      L 0.5 0.5
      L -0.5 0.5
      Z
    `;
  }

  calcTextMargin() {
    const margins = super.calcTextMargin();
    margins.top += 10;
    return margins;
  }
}

export default ShapeManualInput;
